import { render, staticRenderFns } from "./ModalWYSIWYGWidget.vue?vue&type=template&id=e5419998&scoped=true&"
import script from "./ModalWYSIWYGWidget.vue?vue&type=script&lang=js&"
export * from "./ModalWYSIWYGWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalWYSIWYGWidget.vue?vue&type=style&index=0&id=e5419998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5419998",
  null
  
)

export default component.exports